import { ReactComponent as TagIconSVG } from 'assets/images/location/local-offer.svg';
import { ReactComponent as UserIconSVG } from 'assets/images/location/person-pin.svg';
import { ReactComponent as ServicesIconSVG } from 'assets/images/location/restaurant-menu.svg';
import classnames from 'classnames';
import AddDiscoveryConfirm from 'components/AddDiscoveryConfirm';
import AddDiscoveryPlaceImages from 'components/AddDiscoveryPlaceImages';
import AddDiscoveryPlaceInfo, { placeInfoRef } from 'components/AddDiscoveryPlaceInfo';
import AddDiscoverySuccess from 'components/AddDiscoverySuccess';
import Breadcrumb from 'components/App/Breadcrumb';
import Button from 'components/App/Button';
import Meta from 'components/App/Meta';
import React, { useEffect } from 'react';
import { Container, TabContent, TabPane } from 'reactstrap';
import useDiscoveryCreateStore, { initialFormData } from 'store/zustand/useDiscoveryCreateStore';
import { placeImagesRef } from 'components/AddDiscoveryPlaceImages/AddDiscoveryPlaceImages';
import { useHistory } from 'react-router-dom';
import ENDPOINT from 'constants/endPoint';
import styles from './ManagerDiscoveryPlaceCreate.module.scss';

const TITLE = 'Thêm điểm khám phá';

const TAB = {
  INFO: 'INFO',
  IMAGES: 'IMAGES',
  CONFIRM: 'CONFIRM',
  SUCCESS: 'SUCCESS',
};

const breadcrumbList = [
  {
    name: 'Khám phá',
    isActive: false,
    link: '', // TODO: ADD ROUTE WHEN HAVE LINK
  },
  {
    name: 'Thêm điểm khám phá',
    isActive: true,
    link: '',
  },
];

const NAV_TAB = [
  {
    icon: UserIconSVG,
    title: 'Thông tin cơ bản',
    value: TAB.INFO,
  },
  {
    icon: TagIconSVG,
    title: 'Hình ảnh',
    value: TAB.IMAGES,
  },
  {
    icon: ServicesIconSVG,
    title: 'Xác nhận',
    value: TAB.CONFIRM,
  },
];

function ManagerDiscoveryPlaceCreate() {
  const history = useHistory();

  const { formData, setFormData } = useDiscoveryCreateStore();
  const { isInfoValid, isImagesValid } = formData;
  const [step, setStep] = React.useState(TAB.INFO);

  const stepAvailable = React.useMemo(
    () => [
      step,
      ...(isInfoValid ? [TAB.INFO] : []),
      ...(isImagesValid ? [TAB.IMAGES] : []),
      ...(isInfoValid && isImagesValid ? [TAB.CONFIRM] : []),
    ],
    [step, isInfoValid, isImagesValid],
  );

  useEffect(() => () => {
    // Clear form data
    setFormData(initialFormData);
  }, []);

  return (
    <>
      <div className="page-content">
        <Meta name={TITLE} />

        <Container fluid>
          <Breadcrumb pageTitle={TITLE} breadcrumbList={breadcrumbList} />

          {step === TAB.SUCCESS && (
            <AddDiscoverySuccess
              placeName={formData?.name || ''}
              slug={formData?.slug || formData?.id || ''}
              onManage={() => {
                history.push(ENDPOINT.MANAGER_DISCOVERY_PLACE);
              }}
            />
          )}

          {step !== TAB.SUCCESS && (
            <div className={styles.Page}>
              <ul className={classnames(styles.NavMenu, 'custom-scrollbar')}>
                {NAV_TAB.map(({ icon: Icon, title, value }) => (
                  <li key={value}>
                    <Button
                      isDefault
                      classes={classnames(
                        styles.NavMenuItem,
                        stepAvailable.includes(value) &&
                        step !== value &&
                        styles.NavMenuItemDone,
                        step === value && styles.NavMenuItemActive,
                      )}
                      onClick={() => {
                        if (step === TAB.INFO) {
                          placeInfoRef.current.saveData();
                        }

                        if (step === TAB.IMAGES) {
                          placeImagesRef.current.saveData();
                        }

                        if (value === TAB.IMAGES && !isInfoValid) { return; }
                        if (value === TAB.CONFIRM && (!isInfoValid || !isImagesValid)) return;

                        setStep(value);
                      }}
                    >
                      <Icon />

                      <p>{title}</p>
                    </Button>
                  </li>
                ))}
              </ul>

              <section className={styles.NavBody}>
                <TabContent activeTab={step}>
                  <TabPane tabId={TAB.INFO}>
                    <AddDiscoveryPlaceInfo
                      onNext={() => setStep(TAB.IMAGES)}
                      step={step}
                    />
                  </TabPane>

                  <TabPane tabId={TAB.IMAGES}>
                    <AddDiscoveryPlaceImages
                      onBack={() => setStep(TAB.INFO)}
                      onNext={() => setStep(TAB.CONFIRM)}
                      step={step}
                    />
                  </TabPane>

                  <TabPane tabId={TAB.CONFIRM}>
                    <AddDiscoveryConfirm
                      onBack={() => setStep(TAB.IMAGES)}
                      onNext={() => setStep(TAB.SUCCESS)}
                      step={step}
                    />
                  </TabPane>
                </TabContent>
              </section>
            </div>
          )}
        </Container>
      </div>
    </>
  );
}

ManagerDiscoveryPlaceCreate.propTypes = {};

export default ManagerDiscoveryPlaceCreate;
